export default __webpack_public_path__ + "transfix-maps/icons/D2.3a60e3a73293dc7fbdb7f30b24b9cd81.png";